import { API_ROOT } from "../../api-config";
import MemberHelper from "../../helpers/MemberHelper";
import Store from "../../content/Store";
import DateHelper from "../../helpers/DateHelper";
import { shouldShowIfAllSMEModulesDontMatch } from "./../../helpers/SMEModules/smeModuleHelper";
import { nonClaimsModules } from "../../constants/SMEModulesToMatchOn";

const createDocument = ({
  fileName,
  tooltip,
  documentId,
  membershipNumber
}) => ({
  FileName: fileName,
  Tooltip: tooltip,
  ExternalLinkTo: `${API_ROOT}/documents?membershipNumber=${encodeURIComponent(
    membershipNumber
  )}&documentId=${documentId}`,
  ExternalLinkDownload: `${API_ROOT}/documents?membershipNumber=${encodeURIComponent(
    membershipNumber
  )}&documentId=${documentId}&download=true`
});

const createDocumentFromBaseDocument = ({ document, membershipNumber }) => {
  return createDocument({
    fileName: document.Name,
    tooltip: document.Description,
    documentId: document.Id,
    membershipNumber: membershipNumber
  });
};

const getDocumentList = (
  membershipStatement,
  travelDocuments,
  enclosureDocuments,
  isPolicyHolder,
  membershipNumber
) => {
  let documentList = [];
  if (membershipStatement && isPolicyHolder) {
    documentList[0] = createDocument({
      fileName: Store.CoverDocuments.MembershipStatementName,
      tooltip: Store.CoverDocuments.MembershipStatementDescription,
      documentId: membershipStatement.Id,
      membershipNumber: membershipNumber
    });

    if (travelDocuments) {
      documentList = documentList.concat(
        travelDocuments.map((document) => {
          return createDocumentFromBaseDocument({ document, membershipNumber });
        })
      );
    }
  }
  if (enclosureDocuments) {
    documentList = documentList.concat(
      enclosureDocuments.map((document) => {
        return createDocumentFromBaseDocument({ document, membershipNumber });
      })
    );
  }
  return documentList;
};

export const mapStateToProps = ({ policyReducer = {} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;

  if (!selectedPolicy) {
    return {};
  }

  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);
  let membershipStatementMissing = false,
    renewalMembershipStatementMissing = false;
  let isDependant = false;
  let renewalDocumentList = [];

  if (selectedPolicy.ShowRenewalInformation) {
    renewalDocumentList = getDocumentList(
      selectedPolicy.RenewalMembershipStatement,
      selectedPolicy.RenewalTravelDocuments,
      selectedPolicy.RenewalEnclosureDocuments,
      loggedInMember.IsPolicyHolder,
      selectedPolicy.MembershipNumber
    );
  }
  let documentList = getDocumentList(
    selectedPolicy.MembershipStatement,
    selectedPolicy.TravelDocuments,
    selectedPolicy.EnclosureDocuments,
    loggedInMember.IsPolicyHolder,
    selectedPolicy.MembershipNumber
  );

  if (
    !(selectedPolicy.MembershipStatement && loggedInMember.IsPolicyHolder) &&
    loggedInMember.IsPolicyHolder &&
    selectedPolicy.MembershipStatement === null
  ) {
    membershipStatementMissing = true;
  }

  if (
    !(
      selectedPolicy.RenewalMembershipStatement && loggedInMember.IsPolicyHolder
    ) &&
    loggedInMember.IsPolicyHolder &&
    selectedPolicy.RenewalMembershipStatement === null
  ) {
    renewalMembershipStatementMissing = true;
  }

  if (!loggedInMember.IsPolicyHolder) {
    isDependant = true;
  }

  return {
    showCoverAddAPlanLink:
      selectedPolicy.IsFormat2 && !selectedPolicy.IsInternational,
    documentList,
    renewalDocumentList,
    membershipStatementMissing,
    renewalMembershipStatementMissing,
    isDependant,
    membershipNumber: selectedPolicy.MembershipNumber,
    HideCoverDetails: selectedPolicy.IsFormat2,
    isCrestData:selectedPolicy.IsFormat2,
    isSMEModular: selectedPolicy.IsSMEModular,
    isSME: selectedPolicy.IsSME,
    isLargeCorporate: selectedPolicy.IsLargeCorporate,
    isLapsed : selectedPolicy && selectedPolicy.IsLapsed,
    isAgeAbove18,
    shouldShowGuide: shouldShowIfAllSMEModulesDontMatch(
          selectedPolicy,
          nonClaimsModules
        ),
  };
};
